// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-type.js';

import { paths } from '../generated/file-type';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-type', Original, paths);
